import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast.component';
import { TranslationStore } from './core/services/translation.service';
import { SheetGestureService } from './core/services/sheet-gesture.service';
import { ServiceAvailabilityStore } from './core/service-status/service-availability.store';
import { ThemeStore } from './core/stores/theme.store';
import { ServiceUnavailableComponent } from './core/service-status/service-unavailable.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, ServiceUnavailableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <router-outlet />
    <app-toast />
    <!-- Last, and rendered over everything: while it is up, nothing behind it can be worked with
         anyway, and a form that still looks editable is one a venue will lose work in. -->
    <app-service-unavailable />
  `
})
export class AppComponent implements OnInit {
  private readonly translationStore = inject(TranslationStore);
  private readonly sheetGesture = inject(SheetGestureService);
  private readonly availability = inject(ServiceAvailabilityStore);
  // Injected at the root so the persisted theme is stamped on <html> before ANY route
  // paints — including ones outside the dashboard shell (login, /design).
  private readonly themeStore = inject(ThemeStore);

  ngOnInit(): void {
    this.translationStore.init();
    this.sheetGesture.init();
    this.availability.init();
  }
}
